// Dave-Tech lazy mega menu. Shopify renders the menu data once; model links are
// materialised only for the category a customer opens.
(function () {
  const parsedSources = new WeakMap();

  function parseSource(script) {
    if (parsedSources.has(script)) return parsedSources.get(script);

    let groups = [];
    try {
      const payload = JSON.parse(script.textContent || '{}');
      const rawGroups = Array.isArray(payload.g) ? payload.g : Array.isArray(payload.groups) ? payload.groups : [];
      groups = rawGroups.map((rawGroup) => {
        const rawItems = Array.isArray(rawGroup.i) ? rawGroup.i : Array.isArray(rawGroup.items) ? rawGroup.items : [];
        const seenItems = new Set();
        const items = rawItems
          .map((rawItem) => ({
            title: rawItem.t ?? rawItem.title,
            url: rawItem.u ?? rawItem.url,
            current: Boolean(rawItem.c ?? rawItem.current),
            new: Boolean(rawItem.n ?? rawItem.new)
          }))
          .filter((item) => {
            if (!item.title || !item.url) return false;
            const key = `${item.title}\u0000${item.url}`;
            if (seenItems.has(key)) return false;
            seenItems.add(key);
            return true;
          });

        return {
          source: rawGroup.s ?? rawGroup.source,
          title: rawGroup.t ?? rawGroup.title,
          url: rawGroup.u ?? rawGroup.url,
          current: Boolean(rawGroup.c ?? rawGroup.current),
          new: Boolean(rawGroup.n ?? rawGroup.new),
          items
        };
      });
    } catch (error) {
      console.error('DaveTech menu data could not be parsed.', error);
    }

    const map = new Map(groups.filter((group) => group && group.source).map((group) => [group.source, group]));
    parsedSources.set(script, map);
    return map;
  }

  function groupFor(source) {
    if (!source) return null;
    for (const script of document.querySelectorAll('[data-dt-menu-data]')) {
      const group = parseSource(script).get(source);
      if (group) return group;
    }
    return null;
  }

  window.DaveTechMenuData = { get: groupFor };

  function makeBadge() {
    const badge = document.createElement('span');
    badge.className = 'dt-mega-menu__badge';
    badge.textContent = 'NEW';
    return badge;
  }

  function makeLink(item, className, id) {
    const link = document.createElement('a');
    if (id) link.id = id;
    link.href = item.url;
    link.className = className;
    if (item.current) {
      link.classList.add('dt-mega-menu__link--active');
      link.setAttribute('aria-current', 'page');
    }

    const label = document.createElement('span');
    label.textContent = item.title;
    link.appendChild(label);
    if (item.new) link.appendChild(makeBadge());
    return link;
  }

  function safeId(value) {
    return String(value || 'menu').replace(/[^a-z0-9_-]+/gi, '-');
  }

  function renderGroup(menu, source) {
    const panel = menu.querySelector('[data-dt-mega-dynamic]');
    const group = groupFor(source);
    if (!panel || !group) return false;
    if (panel.dataset.dtRenderedSource === source) return true;

    const fragment = document.createDocumentFragment();
    const head = document.createElement('div');
    head.className = 'dt-mega-menu__group-head';
    head.appendChild(makeLink(group, 'dt-mega-menu__group-title link', `HeaderMenuDynamic-${safeId(source)}`));
    if (group.new) head.appendChild(makeBadge());
    fragment.appendChild(head);

    const items = Array.isArray(group.items) ? group.items : [];
    if (items.length) {
      const list = document.createElement('ul');
      list.className = `dt-mega-menu__links list-unstyled${items.length > 10 ? ' dt-mega-menu__links--scroll' : ''}`;
      list.setAttribute('role', 'list');
      if (items.length > 10) {
        list.setAttribute('aria-label', `${group.title} collection links. Scroll for more.`);
      }

      items.forEach((item, index) => {
        const listItem = document.createElement('li');
        listItem.className = 'dt-mega-menu__model-item';
        listItem.appendChild(
          makeLink(item, 'dt-mega-menu__model-link link', `HeaderMenuDynamic-${safeId(source)}-${index + 1}`)
        );
        list.appendChild(listItem);
      });
      fragment.appendChild(list);
    } else {
      fragment.appendChild(makeLink(group, 'dt-mega-menu__model-link dt-mega-menu__model-link--single link'));
    }

    panel.replaceChildren(fragment);
    panel.dataset.dtRenderedSource = source;
    return true;
  }

  function sourceFor(tab) {
    return tab && tab.dataset.dtMenuSource;
  }

  function setTabs(menu, activeTab) {
    menu.querySelectorAll('[data-dt-mega-tab]').forEach(function (item) {
      const isActive = Boolean(activeTab && item === activeTab);
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function setPanel(menu, source) {
    const overview = menu.querySelector('[data-dt-mega-overview]');
    const panel = menu.querySelector('[data-dt-mega-dynamic]');
    const showOverview = !source || !renderGroup(menu, source);

    if (overview) {
      overview.classList.toggle('is-active', showOverview);
      overview.hidden = !showOverview;
    }
    if (panel) {
      panel.classList.toggle('is-active', !showOverview);
      panel.hidden = showOverview;
      if (!showOverview) {
        panel.scrollTop = 0;
        const links = panel.querySelector('.dt-mega-menu__links');
        if (links) links.scrollTop = 0;
      }
    }

    const body = menu.querySelector('.dt-mega-menu__body');
    if (body) body.scrollTop = 0;
    return !showOverview;
  }

  function showOverview(menu) {
    if (!menu || menu.dataset.dtMegaPinned === 'true') return;
    menu.classList.remove('is-previewing', 'is-pinned');
    setTabs(menu, null);
    setPanel(menu, null);
  }

  function previewTab(menu, tab) {
    if (!menu || !tab || menu.dataset.dtMegaPinned === 'true') return;
    const source = sourceFor(tab);
    if (!source || !groupFor(source)) return;
    menu.classList.add('is-previewing');
    menu.classList.remove('is-pinned');
    setTabs(menu, tab);
    setPanel(menu, source);
  }

  function pinTab(menu, tab) {
    if (!menu || !tab) return false;
    const source = sourceFor(tab);
    if (!source || !groupFor(source)) return false;
    menu.dataset.dtMegaPinned = 'true';
    menu.dataset.dtMegaPinnedTarget = source;
    menu.classList.add('is-pinned');
    menu.classList.remove('is-previewing');
    setTabs(menu, tab);
    setPanel(menu, source);
    return true;
  }

  function unpin(menu) {
    if (!menu) return;
    menu.dataset.dtMegaPinned = 'false';
    menu.dataset.dtMegaPinnedTarget = '';
    menu.classList.remove('is-pinned', 'is-previewing');
    setTabs(menu, null);
    setPanel(menu, null);
  }

  function initMegaMenu(menu) {
    if (!menu || menu.dataset.dtMegaInitialised === 'true') return;
    menu.dataset.dtMegaInitialised = 'true';
    menu.dataset.dtMegaPinned = 'false';

    menu.querySelectorAll('[data-dt-mega-tab]').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        previewTab(menu, tab);
      });
      tab.addEventListener('mouseleave', function () {
        showOverview(menu);
      });
      tab.addEventListener('focus', function () {
        previewTab(menu, tab);
      });
      tab.addEventListener('click', function (event) {
        if (pinTab(menu, tab)) event.preventDefault();
      });
    });

    menu.querySelectorAll('[data-dt-mega-reset]').forEach(function (reset) {
      reset.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
      reset.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        unpin(menu);
      });
    });

    menu.addEventListener('toggle', function () {
      if (menu.open) unpin(menu);
    });
    unpin(menu);
  }

  function initAll() {
    document.querySelectorAll('.dt-mega-menu').forEach(initMegaMenu);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const pinned = document.querySelector('.dt-mega-menu[open].is-pinned');
    if (pinned) unpin(pinned);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
